import { render, staticRenderFns } from "./UnderVideoPromotionalBanners.vue?vue&type=template&id=03cc1e41&scoped=true&"
import script from "./UnderVideoPromotionalBanners.vue?vue&type=script&lang=js&"
export * from "./UnderVideoPromotionalBanners.vue?vue&type=script&lang=js&"
import style0 from "./UnderVideoPromotionalBanners.vue?vue&type=style&index=0&id=03cc1e41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cc1e41",
  null
  
)

component.options.__file = "UnderVideoPromotionalBanners.vue"
export default component.exports